import type { MigrationStrategies } from 'rxdb';
import type { AssetSectionDefinationsListDocument } from './assetSectionDefinition.types';

export const assetSectionDefinationsListMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: AssetSectionDefinationsListDocument) => ({ ...oldDoc, id: oldDoc.id.toString() }),
};
